// Libraries
import { action, computed, observable, runInAction } from "mobx";

// Core
import { FieldType } from "Core/Utils/Utils";
import { ViewModelBase } from "Core/ViewModels";

// Custom
import { Server } from "Custom/Globals/AppUrls";
import { ApiStatus } from "Custom/Models/Enums/ApiStatus";
import { InspectionDocumentDTO, InspectionDocumentModel } from "Custom/Models/DashboardModels/InspectionDocumentModel";
import { isNullOrUndefined } from "util";

export class InspectionDocumentViewModel extends ViewModelBase<InspectionDocumentModel> {
    constructor(propertyId: string) {
        super(new InspectionDocumentModel());
        this.setDecorators(InspectionDocumentModel);

        this.propertyId = propertyId;

        if (!isNullOrUndefined(propertyId)) {
            this.load(propertyId);
        }
    }

    // #region Properties
    @observable
    public propertyId: string = "";

    @observable
    public apiStatus: ApiStatus = ApiStatus.loading;

    @observable
    public documents: InspectionDocumentModel[] = [];
    // #endregion Properties

    // #region Computeds
    @computed
    public get ApiStatus(): ApiStatus {
        return this.apiStatus;
    }
    // #endregion Computeds

    // #region Actions
    @action
    public setApiStatus(apiStatus: ApiStatus) {
        this.apiStatus = apiStatus;
    }

    public navigateToDashboard = () => {
        this.history.push(`/${this.propertyId}`);
    };

    private load = async (propertyId: string): Promise<void> => {
        this.setApiStatus(ApiStatus.loading);

        try {
            const apiResult = await this.Get<InspectionDocumentDTO[]>(Server.Api.Dashboard.GetInspectionDocuments + "/" + propertyId);

            if (apiResult.wasSuccessful) {
                runInAction(() => {
                    this.documents = apiResult.payload.map(dto => {
                        const model = new InspectionDocumentModel();
                        model.fromDto(dto);
                        return model;
                    });
                });
                this.setApiStatus(ApiStatus.success);
            } else {
                this.setApiStatus(ApiStatus.error);
            }
        } catch (exception) {
            console.error("Error loading inspection documents:", exception);
            this.setApiStatus(ApiStatus.error);
        } finally {
            // Optionally add cleanup actions here
        }
    };
    // #endregion Actions

    // #region Boilerplate
    public afterUpdate: undefined;
    public beforeUpdate: undefined;

    public isFieldValid(fieldName: keyof FieldType<any>): boolean {
        return true;
    }
    // #endregion Boilerplate
}
